import { render, staticRenderFns } from "./HotelDetailsDrawer.vue?vue&type=template&id=dc2bffd0&scoped=true"
import script from "./HotelDetailsDrawer.vue?vue&type=script&lang=js"
export * from "./HotelDetailsDrawer.vue?vue&type=script&lang=js"
import style0 from "./HotelDetailsDrawer.vue?vue&type=style&index=0&id=dc2bffd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2bffd0",
  null
  
)

export default component.exports